module.exports = __webpack_public_path__ + "img/2-4.f5384832.svg";